<template>
  <div class="start">

    <send-sample-dialog :samples="EXAMPLES" />

    <start-header
      :media="{ id: '692658bb-99df-4546-abed-5deee95277e3', alt: 'Invitations', video: true }"
      :bg="{ src: 'https://cdn.ellacard.com/media/79a3cfe8-f198-4fc9-b619-36bb35384f66/lg.mp4', color: '#EF9C7E' }"
      :to="{ name: 'catalog-category', params: { category: 'invitations' }, hash: '#search' }"
      @click-laptop="global.lastSelectedType = 'INVITATION'"
    >
      <template v-slot:h1>Invitations from Ellacard</template>
      <template v-slot:h2>The best way to create and send beautiful custom invitations and collect RSVPs.<!--Add your own text, pictures, videos, GIFs, and more.--></template>
    </start-header>

    <start-layer clip-waves-class="light-gradient" :offset=".75">

      <div class="actions">
        <v-btn class="btn-pop" x-large rounded dark color="ec-blue" :to="{ name: 'catalog-category', params: { category: 'invitations' }, hash: '#search' }" @click.capture="global.lastSelectedType = 'INVITATION'">Start an invitation <v-icon v-html="mdiChevronRight" /></v-btn>
        <v-btn class="btn-pop" x-large rounded dark color="pink" :to="{ hash: '#demo-first-birthday' }">Try demo…</v-btn>
      </div>

      <div class="grid-alternate">

        <web-media
          class="hover-pop rounded-xl white"
          aspect-ratio="4 / 3"
          id="3cedcd52-e788-442c-9ba7-bd207dca0ce0"
          alt="Ellacard invitation customization examples"
          is-video
        />

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiPencil" /> Customize everything</h4>
          <div>
            Use our design tools to add your own pages with your own flare, complete with confetti, music, and backgrounds.
          </div>
        </div>

        <div class="relative hover-pop-group" style="aspect-ratio: 1;">
          <div class="absolute rounded rn2 overflow-auto" style="width: 85%; top: 0; left: 0; max-height: 100%;">
            <web-media
              class="white"
              aspect-ratio="902 / 1282" id="ef377a9f-b5cc-4736-9cf2-ee5c9055cd36" alt="Example guest list"
            />
          </div>
          <web-media
            class="absolute rounded r5 white"
            style="width: 50%; top: 15%; right: 0;"
            aspect-ratio="444 / 640" id="733f122c-01fb-47a1-ad70-a0447f941acd" alt="Example RSVP form"
          />
        </div>

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiCalendarQuestion" /> Collect RSVPs</h4>
          <div>
            Ask whatever questions you want with your own custom RSVP form. Set permissions for who can respond. We'll keep track of all the responses.
          </div>
        </div>

        <div class="relative hover-pop-group" style="aspect-ratio: 4 / 3;">
          <div
            class="absolute rounded grey lighten-5 d-flex flex-column rn5"
            style="width: 60%; left: 2%; max-height: 100%;"
          >
            <div class="px-3 pt-2 text-left text--label-active">You're invited</div>
            <div class="px-3 pb-2 text-left text--label-active">To: ray@example.com</div>
            <v-divider />
            <div class="pa-3 overflow-auto">
              <web-media
                class="grey lighten-5"
                aspect-ratio="376 / 640" id="36ec28cf-5995-455c-83d4-c6a4693e013b" alt="Example invitation email"
              />
            </div>
          </div>
          <web-media
            class="absolute has-alpha r5"
            style="width: 50%; top: 12%; right: 1%;"
            aspect-ratio="560 / 640" id="ec6d68fa-976b-469b-bcd3-09a393e8c412" alt="Example invitation text message"
          />
        </div>

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiEmailFast" /> Track deliveries</h4>
          <div>Send your invitation via email, text, or post a link on any platform. We'll keep track of all deliveries and report any issues, like out-of-date contact information.</div>
        </div>

        <div class="relative hover-pop-group" style="aspect-ratio: 4 / 3;">
          <web-media
            class="absolute rounded r5 white"
            style="width: 50%; top: 0; right: 2%;"
            aspect-ratio="444 / 640" id="f83fdd46-5c0b-432d-9cd4-58c80fe4f507" alt="Example invitation follow-up"
          />
          <web-media
            class="absolute rounded rn3 white"
            style="width: 60%; top: 12%; left: 1%;"
            aspect-ratio="640 / 550" id="25140c51-509a-4195-a1ee-5fae779fccd0" alt="Example send follow-up settings"
          />
        </div>

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiReminder" /> Send reminders and updates</h4>
          <div>Remind guests to RSVP or notify them of any changes.</div>
        </div>

        <web-media
          class="hover-pop rounded-xl white"
          aspect-ratio="4 / 3" id="5113219f-9084-4745-b0fd-b0b830ae9447" alt="Piggy bank savings"
        />

        <div>
          <h4 class="mb-3"><v-icon v-html="mdiCurrencyUsd" /> Pay less, get more</h4>
          <div>
            Ellacard is the most affordable way to send an e-invitation. We think you'll come back to use our <router-link :to="{ name: 'start-group-cards' }">group cards</router-link>, <router-link :to="{ name: 'start-holidays' }">holiday cards</router-link>, <router-link :to="{ name: 'start-recognition' }">cards for the office</router-link>, and more. <router-link :to="{ name: 'pricing', hash: '#subscriptions' }">Become a subscriber</router-link> for even steeper discounts.
          </div>
        </div>

        <!--
        <v-lazy style="aspect-ratio: 4 / 3;">
        </v-lazy>

        <div>
          <h3 class="text-h6 text-md-h5 header-font font-weight-bold mb-3">
            <v-icon class="mr-2" x-large v-html="mdiVideoVintage" /> Video invitations
          </h3>
          <div class="text-md-h6">Make a custom video invitation right in your browser.</div>
        </div>
        -->

      </div>

      <div class="actions">
        <v-btn class="btn-pop" x-large rounded dark color="ec-blue" :to="{ name: 'catalog-category', params: { category: 'invitations' }, hash: '#search' }" @click.capture="global.lastSelectedType = 'INVITATION'">Start an invitation <v-icon v-html="mdiChevronRight" /></v-btn>
        <v-btn class="btn-pop" x-large rounded dark color="pink" :to="{ hash: '#demo-first-birthday' }">Try demo…</v-btn>
      </div>

    </start-layer>

    <start-layer clip-waves-class="dark-gradient" :offset=".9">
      <h2>Examples</h2>

      <div class="grid-alternate">
        <template v-for="ex in EXAMPLES">
          <router-link
            class="d-block relative hover-pop rounded-xl"
            style="aspect-ratio: 4 / 3;"
            v-bind:style="{ 'background-color': ex.color }"
            :title="ex.title + ' invitation demo'"
            :to="{ hash: ex.hash }"
          >
            <card-background class="overflow-hidden" style="border-radius: 24px;" :src="ex.bg" />
            <start-preview
              style="pointer-events: none; top: 10%; left: 5%; width: 90%;"
              :alt="ex.title + ' example card'"
              :pages="ex.pages"
            />
          </router-link>
          <div>
            <h4 class="mb-3">{{ex.title}}</h4>
            <div class="mb-6">{{ex.subtitle}}</div>
            <div class="ma-n2">
              <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" :title="ex.title + ' invitation demo'" :to="{ hash: ex.hash }">
                Try demo…
              </v-btn>
              <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" :title="ex.title + ' invitations'" :to="{ name: 'catalog-category', params: { category: ex.category } }" @click.capture="global.lastSelectedType = 'INVITATION'">More like this <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
            </div>
          </div>
        </template>
      </div>

      <div class="actions">
        <v-btn class="btn-pop" x-large rounded dark color="ec-blue" :to="{ name: 'catalog-category', params: { category: 'invitations' }, hash: '#search' }" @click.capture="global.lastSelectedType = 'INVITATION'">Start an invitation <v-icon v-html="mdiChevronRight" /></v-btn>
      </div>
    </start-layer>

    <!--
    <start-layer clip-waves-class="red-gradient" :offset=".9">
      <v-container class="pt-16 pb-0 text-md-h6" fluid>
        <p>This was perfect! I could not believe how much [another service] was charging to send a glorified email that didn't even have the RSVP options and permissions that I was looking for. Having Ellacard text people for me and then being able to share the event link was perfect. On top of that, it also looks the best and is by far the most fun to set up, I definitely spent way too long playing with the confetti… My one complaint is that it was hard to figure out how to fit in a group video. I didn't end up using that option, but Kevin from support was very helpful and showed me how it works!</p>
        <p>– Person 1</p>

        <p>The ability to have complete creative control over my dad's birthday e-vite is exactly what I was looking for. I tried other websites which looked good, but felt really generic. Huge plus to be able to add all sorts of photos and videos instead of just formal stuffy text (I added 10 extra pages and it was FREE). Also you can drag and drop everything and it works really well on your phone, it's clear they spent a ton of time on that. Love that there are no ticky-tacky upcharges!</p>
        <p>– Person 2</p>

        <p>Ellacard is a hidden gem for sure! We recently started using their group cards at work, and then I discovered that they also had invitations, so I used it to send one out for my daughter's 7th birthday. It's super fun to play around with all the options. I did get confused with the options to re-send, but their support was really good about clearing things up. They actually track if you have a typo in a phone number or email address (which I did in several). I was very impressed. I've sent other e-invitations in the past that didn't bother to do that. Would definitely use again.</p>
        <p>– Person 3</p>
      </v-container>
    </start-layer>
    -->

    <!-- TODO: use the tag 'IN' when you get some corresponding reviews -->
    <start-reviews tag="IN" />

    <start-footer />

  </div>
</template>


<style scoped>
.rsvp-preview {
  cursor: pointer;
}
.rsvp-preview img {
  transition: transform .12s, filter .12s;
}
.rsvp-preview:hover img {
  filter: drop-shadow(0 3px 3px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.14)) drop-shadow(0 1px 10px rgba(0, 0, 0, 0.12));
  transform: scale(1.03);
}
.rsvp-form-preview {
  filter: drop-shadow(0 3px 1px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.14)) drop-shadow(0 1px 5px rgba(0, 0, 0, 0.12));
  transform: rotate(-5deg);
}
.rsvp-preview:hover img.rsvp-form-preview {
  transform: scale(1.03) rotate(-5deg);
}


/* Use this class for elements where box-shadow doesn't apply, i.e. elements that aren't perfectly rectangular */
.pseudo-elevation {
  filter: drop-shadow(0 3px 1px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.14)) drop-shadow(0 1px 5px rgba(0, 0, 0, 0.12));
}

  /*
  .hover-pop-container {
    cursor: pointer;
  }
  .hover-pop-container > * {
    transition: transform .12s, filter .12s;
    filter: drop-shadow(0 3px 1px rgba(0, 0, 0, 0.1)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.14)) drop-shadow(0 1px 5px rgba(0, 0, 0, 0.12));
  }
  .hover-pop-container:hover > * {
    transform: scale(1.03);
    filter: drop-shadow(0 3px 1px rgba(0, 0, 0, 0.2)) drop-shadow(0 2px 2px rgba(0, 0, 0, 0.14)) drop-shadow(0 1px 5px rgba(0, 0, 0, 0.12));
  }
  */
</style>


<script>
import CardBackground from '@/components/CardBackground.vue';
import SendSampleDialog from '@/components/SendSampleDialog.vue';
import StartFooter from '@/components/StartFooter.vue';
import StartHeader from '@/components/StartHeader.vue';
import StartLayer from '@/components/StartLayer.vue';
import StartPreview from '@/components/StartPreview.vue';
import StartReviews from '@/components/StartReviews.vue';
import WebMedia from '@/components/WebMedia.vue';
import { mdiPencil, mdiCalendarQuestion, mdiEmailFast, mdiReminder, mdiVideoVintage, mdiClose, mdiPlay, mdiVideo, mdiHelpCircle, mdiDomain, mdiCakeVariant, mdiWalletGiftcard, mdiEmoticonSad, mdiChevronRight, mdiCurrencyUsd } from '@mdi/js';


const EXAMPLES = [
  {
    id: '2c662393-e0c4-42f1-a3e1-79909b2338d9',
    title: 'First birthday party',
    subtitle: "This floral chalkboard invitation is the perfect way to kick off the celebration of your child's first birthday!",
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/e4050073-a328-45c3-96ef-2416b3bba1b8_270x378.jpg"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/6f2721f2-4fd4-4905-b135-270aa1260fbe_270x378.jpg"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/8ada1f69-6098-468f-bb51-ef2b769c9cd8_270x378.jpg"
      }
    ],
    color: "#efefef",
    bg: "https://cdn.ellacard.com/page_backgrounds/White flowers.jpg",
    hash: '#demo-first-birthday',
    category: 'birthday-invitations'
  },
  {
    id: 'e8687c96-0dc0-4f41-b3b1-2d92ba195079',
    title: '60th birthday party',
    subtitle: 'A simple but classy invitation for someone sophisticated to celebrate a big milestone.',
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/2d54f004-4580-4253-9caa-440bc412235d_270x378.jpg"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/83946c0d-bba8-4ee2-aef9-7c14d9fe0c92_270x378.jpg"
      }
    ],
    color: "#9D7365",
    bg: "https://cdn.ellacard.com/page_backgrounds/Light Terracotta.jpg",
    hash: '#demo-milestone-birthday',
    category: 'birthday-invitations'
  },
  {
    id: '24c9c5bb-894e-4661-bf9a-fed66d26aad9',
    title: 'Summer baby shower',
    subtitle: 'Celebrate the mom-to-be with this charming baby shower invite featuring soft, summer blooms.',
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/d2498da9-32d6-431f-bbc0-bc8f9a15e274_270x378.jpg"
      }
    ],
    color: "#C8C4B9",
    bg: "https://cdn.ellacard.com/page_backgrounds/Elegant Beige.jpg",
    hash: '#demo-baby-shower',
    category: 'baby-shower-invitations'
  },
  {
    id: '73630b73-c3e4-4d1b-882f-be85844d8451',
    title: 'BBQ blowout',
    subtitle: "Bring the heat to your backyard bash with this smokin' hot BBQ invite.",
    pages: [
      {
        "webp": "https://cdn.ellacard.com/r/4349c329-8fd7-4113-a5ee-faeca93b2d80_270x378.webp",
        "mp4": "https://cdn.ellacard.com/r/4349c329-8fd7-4113-a5ee-faeca93b2d80_270x378.mp4"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/f7ea0b1d-8757-4ea0-b18f-e82487c2ada2_270x378.jpg"
      }
    ],
    color: "#853C1C",
    bg: "https://cdn.ellacard.com/page_backgrounds/Fire 2.mp4",
    hash: '#demo-bbq',
    category: 'barbecue-invitations'
  },
  {
    id: '24774de8-f99c-41b9-9cbf-767762f8fd39',
    title: 'Graduation party',
    subtitle: 'Cap, gown, and golden sparkles – this graduation invitation makes the perfect start to a grand celebration.',
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/f3f12f64-7388-4b86-863a-792436d69e70_270x378.jpg"
      },
      {
        "webp": "https://cdn.ellacard.com/r/325a0e99-6037-4427-b224-88c0b998f3c0_270x378.webp",
        "mp4": "https://cdn.ellacard.com/r/325a0e99-6037-4427-b224-88c0b998f3c0_270x378.mp4"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/d6d4e6ff-1b94-41d1-adb0-8aec41501044_270x378.jpg"
      }
    ],
    color: "#9A640C",
    bg: "https://cdn.ellacard.com/page_backgrounds/Gold Stage.mp4",
    hash: '#demo-graduation',
    category: 'graduation-invitations'
  },
  {
    id: 'd7328329-f1c7-463a-ae4f-d76b5e3e27bf',
    title: 'Easter brunch',
    subtitle: 'Invite everyone to hop on over for a joyful Easter luncheon with this festive invitation.',
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/2173ffe6-0d08-428e-b68c-702789e9fec5_270x378.jpg"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/26ca177e-5154-463c-9a39-42c66a1af6c2_270x378.jpg"
      },
      {
        "webp": "https://cdn.ellacard.com/r/5480e0cb-201a-45e9-8754-7d656f143568_270x378.webp",
        "mp4": "https://cdn.ellacard.com/r/5480e0cb-201a-45e9-8754-7d656f143568_270x378.mp4"
      }
    ],
    color: "#9AA757",
    bg: "https://cdn.ellacard.com/page_backgrounds/Flower Meadow Closeup.mp4",
    hash: '#demo-easter',
    category: 'easter-invitations'
  },
  {
    id: '6df0e1e9-3ff7-4d9c-a2df-938abfc0c104',
    title: 'Thanksgiving dinner',
    subtitle: 'Gather friends and family together to give thanks with this charming fall themed Thanksgiving party invite.',
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/ec8f5915-a80b-4866-8ab5-eea47776029e_270x378.jpg"
      },
      {
        "jpg": "https://cdn.ellacard.com/r/129692ef-8ad3-4e7d-838a-9909962f44bd_270x378.jpg"
      }
    ],
    color: "#ed9937",
    bg: "https://cdn.ellacard.com/page_backgrounds/Fall Leaves.jpg",
    hash: '#demo-thanksgiving',
    category: 'thanksgiving-invitations'
  },
  {
    id: 'c4c340c7-9c06-437e-b77b-c3a467ff9219',
    title: 'Holiday party',
    subtitle: 'Raise a glass to holiday cheer with this festive and fun Christmas party invitation.',
    pages: [
      {
        "jpg": "https://cdn.ellacard.com/r/dc95ab32-4ef8-4bf6-a68c-dc74a88187b9_270x378.jpg"
      },
      {
        "webp": "https://cdn.ellacard.com/r/e68db244-7dc3-4439-819a-76357ab428a1_270x378.webp",
        "mp4": "https://cdn.ellacard.com/r/e68db244-7dc3-4439-819a-76357ab428a1_270x378.mp4"
      }
    ],
    color: "#FF0C28",
    bg: "https://cdn.ellacard.com/page_backgrounds/Sparse Red.jpg",
    hash: '#demo-holiday-party',
    category: 'holiday-party-invitations'
  }
];


export default {
  name: 'start-group-cards',

  routerViewMeta: {
    $class: 'fade-transparent',
    $subtitle: 'Invitations',
    description: 'The best way to create and send beautiful custom invitations and collect RSVPs'
  },

  components: {
    CardBackground,
    SendSampleDialog,
    StartFooter,
    StartHeader,
    StartLayer,
    StartPreview,
    StartReviews,
    WebMedia
  },

  data() {
    return {
      mdiClose,
      mdiPlay,
      mdiVideo,
      mdiHelpCircle,
      start: null
    }
  },

  created() {
    Object.assign(this, { EXAMPLES, mdiPencil, mdiCalendarQuestion, mdiEmailFast, mdiReminder, mdiVideoVintage, mdiChevronRight, mdiCurrencyUsd });
  },

  mounted() {
    window.GLOBAL.lastSelectedType = 'INVITATION';
  }
}
</script>
